import { render, staticRenderFns } from "./addRegion.vue?vue&type=template&id=af1be08e&scoped=true"
import script from "./addRegion.vue?vue&type=script&lang=js"
export * from "./addRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1be08e",
  null
  
)

export default component.exports